import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {toast} from 'react-toastify';
import {GAME_PHASE_PLAYING, GAME_PHASE_WAITING_FOR_PLAYERS} from '../../../configs/constants';
import {youCantJoinMessage, youCantJoinFullGameMessage} from '../../../configs/messages';
import GamesRow from './GamesRow';
import {Button, Search, InfiniteScroller, ThemeContext} from '../../common';
import JoinGameModal from './JoinGameModal';
import {ON_MODAL_OPEN} from '../../../actions/types';
import {appId} from '../../../store';

const toastProps = {position: toast.POSITION.TOP_CENTER, autoClose: 10000};

export default class GamesList extends Component {
  static propTypes = {
    branchIoLink: PropTypes.string.isRequired,
    gameList: PropTypes.arrayOf(
      PropTypes.shape({})
    ).isRequired,
    hasMore: PropTypes.bool.isRequired,
    onFetchGames: PropTypes.func.isRequired,
    onJoinGame: PropTypes.func.isRequired,
    isLandingShowed: PropTypes.bool.isRequired,
    ableToSendGiftsForFree: PropTypes.bool.isRequired,
    gameConfig: PropTypes.shape({
      isAudienceAllowed: PropTypes.bool,
    }).isRequired,
    onConfirmMedia: PropTypes.func.isRequired,
    query: PropTypes.string,
    fetchGameTeamDefinition: PropTypes.func.isRequired,
    fetchMobileBranchIoLink: PropTypes.func.isRequired,
    saveUserDefinitions: PropTypes.func.isRequired,
    onPlayerEnteredGameByDirectLink: PropTypes.func.isRequired,
    currentTeamDefinition: PropTypes.shape({
      leftTeamName: PropTypes.string,
      rightTeamName: PropTypes.string,
      playerDefinition: PropTypes.arrayOf(PropTypes.string),
      teamDefinition: PropTypes.shape({
        preselected: PropTypes.string,
        field: PropTypes.string,
        values: PropTypes.arrayOf(PropTypes.string),
      }),
    }).isRequired,
    fetchingCurrentTeamDefinition: PropTypes.bool.isRequired,
    user: PropTypes.shape({}).isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    query: '',
  };

  state = {
    isModalOpened: false,
    currentGame: null,
  };

  onPopupShow = () => {
    const {dispatch} = this.props;
    dispatch({type: ON_MODAL_OPEN});
  };

  onSearch = (query) => {
    const {onFetchGames} = this.props;
    onFetchGames({query, resetPage: true});
  };

  onSelect = async ({id: gameId}) => {
    const selectedGame = this.props.gameList.find(g => g.id === gameId);
    const {
      isAudienceAllowed,
      hasAlreadyJoined,
      leftTeam: {playersCount: leftTeamCount},
      playerLimit,
      rightTeam: {playersCount: rightTeamCount},
      state,
    } = selectedGame;
    const isGameFull = (rightTeamCount + leftTeamCount) === playerLimit;

    if (state === GAME_PHASE_WAITING_FOR_PLAYERS && !isAudienceAllowed && isGameFull) {
      toast.error(youCantJoinFullGameMessage, toastProps);

      return false;
    }
    if (state === GAME_PHASE_PLAYING && !hasAlreadyJoined && !isAudienceAllowed) {
      toast.error(youCantJoinMessage, toastProps);

      return false;
    }
    await this.props.onPlayerEnteredGameByDirectLink({appId, gameId});

    return this.setState({
      isModalOpened: true,
      currentGame: selectedGame,
    });
  };

  onModalClose = () => {
    this.setState({
      isModalOpened: false,
    });
  };

  renderGames = gameList => gameList.map((game) => {
    const {gameConfig: {playerLimit}} = this.props;
    return (
      <GamesRow {...game} playerLimit={playerLimit} onGameSelected={this.onSelect} key={game.id}/>
    );
  });

  render() {
    const {currentGame, isModalOpened} = this.state;
    const {
      branchIoLink,
      gameList,
      onFetchGames,
      hasMore,
      query,
      gameConfig: {isAudienceAllowed},
      onJoinGame,
      isLandingShowed,
      onConfirmMedia,
      fetchGameTeamDefinition,
      fetchMobileBranchIoLink,
      saveUserDefinitions,
      currentTeamDefinition,
      fetchingCurrentTeamDefinition,
      ableToSendGiftsForFree,
      user,
    } = this.props;

    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const styles = {color: theme.primaryColor};

          return (
            <div className="games-list">
              <div className="games-list_m_actions">
                <div className="games-list_m_actions-cell">
                  <Search onSearch={this.onSearch}/>
                </div>
                <div className="games-list_m_actions-cell text-right">
                  <Button
                    text="Create new game"
                    size="xs"
                    icon="plus"
                    className="new-game-btn button_rounded"
                    handler={this.onPopupShow}
                  />
                </div>
              </div>
              <div className="games-list__titles row row_space-between row_vcenter">
                <div className="cell row row_vcenter">
                  <h4 className="title">Games</h4>
                  <Search onSearch={this.onSearch} shrink/>
                </div>
                <div className="cell cell_auto">
                  <h4 className="title">players</h4>
                </div>
              </div>
              <ul className="games-list__content custom-overflow" style={styles}>
                <InfiniteScroller
                  loadMore={() => onFetchGames({query})}
                  hasMore={hasMore}
                >
                  {this.renderGames(gameList)}
                </InfiniteScroller>
              </ul>
              {currentGame &&
                <JoinGameModal
                  branchIoLink={branchIoLink}
                  ableToSendGiftsForFree={ableToSendGiftsForFree}
                  currentGame={currentGame}
                  isModalOpened={isModalOpened}
                  onModalClose={this.onModalClose}
                  color={theme.secondaryColor}
                  barColor={theme.primaryColor}
                  isAudienceAllowed={isAudienceAllowed}
                  onJoinGame={onJoinGame}
                  isLandingShowed={isLandingShowed}
                  onConfirmMedia={onConfirmMedia}
                  fetchGameTeamDefinition={fetchGameTeamDefinition}
                  saveUserDefinitions={saveUserDefinitions}
                  currentTeamDefinition={currentTeamDefinition}
                  fetchingCurrentTeamDefinition={fetchingCurrentTeamDefinition}
                  fetchMobileBranchIoLink={fetchMobileBranchIoLink}
                  user={user}
                />
              }
            </div>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}
